import { useEffect, useState } from "react";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_PARKER_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { getProgressBarValue, phoneNumberToSend } from "../../../../../utils/CommonUtils";
import {
  getErrorMessage,
  isEmail,
  isNameValid,
  isTextValid,
  isPhoneNumber,
  isRequired,
} from "../../../../../utils/FormUtils";
// import SwitchInput from "../../../Inputs/CustomInputs/SwitchInput";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import UploadImageInput from "../../../Inputs/CustomInputs/UploadImageInput";
import VerificationPhoneInput from "../../../Inputs/CustomInputs/VerificationPhoneInput";
import PhoneInputWithoutVerification from "../../../Inputs/CustomInputs/PhoneInputWithoutVerification";
import VerificationPINInput from "../../../Inputs/CustomInputs/VerificationPINInput";
import classes from "../WizardForm.module.css";
import CheckboxInput from "../../../Inputs/CustomInputs/CheckboxInput";

const GeneralDetailsStep = (props) => {
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (props.currentStep === ADD_PARKER_FORM_STEPS.GENERAL_DETAILS) {
      const stepHeader = new StepHeaderEntity(
        props.isEditMode
          ? props.isGmtDetails
            ? Strings.STEPS_TITLES.EDIT_PROFILE_DETAILS_TITLE
            : Strings.STEPS_TITLES.GENERAL_DETAILS_EDIT_MODAL_TITLE
          : Strings.STEPS_TITLES.GENERAL_DETAILS_MODAL_TITLE,
        props.isEditMode
          ? props.isGmtDetails
            ? Strings.STEPS_TITLES.EDIT_PROFILE_DETAILS_SUB_TITLE
            : Strings.STEPS_TITLES.GENERAL_DETAILS_EDIT_MODAL_SUB_TITLE
          : Strings.STEPS_TITLES.GENERAL_DETAILS_MODAL_SUB_TITLE,
        Icons.NEW_PARKER,
        props.isEditMode
          ? null
          : getProgressBarValue(ADD_PARKER_FORM_STEPS.GENERAL_DETAILS)
      );

      store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
    }

    if (props.currentStep === ADD_PARKER_FORM_STEPS.GENERAL_DETAILS) {
      const hasError = Object.values(errors).some((hasError) => hasError);
      props.handleCurrentStepValidity(hasError);
    }
  }, [errors]);

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  if (props.currentStep !== ADD_PARKER_FORM_STEPS.GENERAL_DETAILS) {
    return null;
  } else return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {Strings.STEPS_TITLES.GENERAL_DETAILS_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
        {Strings.STEPS_TITLES.GENERAL_DETAILS_SUB_TITLE}
      </span>

      <div className={classes.fileds}>
        <TextInput
          label={Strings.INPUT_LABELS.FIRST_NAME}
          id={INPUTS_PROPS.FIRST_NAME}
          value={props.firstName}
          defaultValue={props.firstName}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          hasError={!isRequired(props.firstName).isValid || !isNameValid(props.firstName).isValid}
          errorMessage={getErrorMessage(isRequired(props.firstName)) ? getErrorMessage(isRequired(props.firstName)) : getErrorMessage(isNameValid(props.firstName))}
          disabled={props.fromGmt && props.isPhoneVerified}
        />
        <TextInput
          label={Strings.INPUT_LABELS.LAST_NAME}
          id={INPUTS_PROPS.LAST_NAME}
          value={props.lastName}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          hasError={!isRequired(props.lastName).isValid || !isNameValid(props.lastName).isValid}
          errorMessage={getErrorMessage(isRequired(props.lastName)) ? getErrorMessage(isRequired(props.lastName)) : getErrorMessage(isNameValid(props.lastName))}
          disabled={props.fromGmt && props.isPhoneVerified}
        />
        <PhoneInputWithoutVerification
          label={Strings.INPUT_LABELS.PHONE_NUMBER}
          id={INPUTS_PROPS.PHONE_NUMBER}
          phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
          value={props.phoneNumber}
          actionText={
            props.isEditMode ? Strings.CHANGE : Strings.VERIFY /* Strings.CONFIRM_VERIFY */
          }
          dialingCode={props.dialingCode}
          isEditMode={props.isEditMode}
          isPhoneVerified={props.isPhoneVerified}
          onChange={props.handleChange}
          handleError={handleError} // added
          isStepSubmitted={props.isStepSubmitted}
          hasError={!isRequired(props.phoneNumber).isValid || !isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)).isValid}
          errorMessage={getErrorMessage(isRequired(props.phoneNumber)) ? getErrorMessage(isRequired(props.phoneNumber)) : getErrorMessage(isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)))}
          isVerifyValidationNeeded={true}
          fromGmt={props.fromGmt}
          selectedSites={props.selectedSites}
          disabled={props.fromGmt && props.isPhoneVerified}
          // {...props}
        />
        {/* <VerificationPhoneInput
          label={Strings.INPUT_LABELS.PHONE_NUMBER}
          id={INPUTS_PROPS.PHONE_NUMBER}
          phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
          value={props.phoneNumber}
          isEditMode={props.isEditMode}
          actionText={
            props.isEditMode ? Strings.CHANGE : Strings.CONFIRM_VERIFY
          }
          dialingCode={props.dialingCode}
          isPhoneVerified={props.isPhoneVerified}
          onChange={props.handleChange}
          handleError={handleError}
          isStepSubmitted={props.isStepSubmitted}
          originalPhoneNumber={props.originalPhoneNumber}
          hasError={!isRequired(props.phoneNumber).isValid || !isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)).isValid}
          errorMessage={getErrorMessage(isRequired(props.phoneNumber)) ? getErrorMessage(isRequired(props.phoneNumber)) : getErrorMessage(isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)))}
          fromGmt={props.fromGmt}
          selectedSites={props.selectedSites}
          disabled={props.fromGmt && props.isPhoneVerified}
        /> */}
        <TextInput
          label={Strings.INPUT_LABELS.EMAIL}
          id={INPUTS_PROPS.EMAIL}
          value={props.email}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          onChange={props.handleChange}
          hasError={!isEmail(props.email).isValid}
          errorMessage={getErrorMessage(isEmail(props.email))}
          disabled={props.fromGmt && props.isPhoneVerified}
        />

        {!props.isGmtDetails && (
          <TextInput
            label={Strings.INPUT_LABELS.PERSIONAL_ID}
            id={INPUTS_PROPS.PERSIONAL_ID}
            value={props.kioskLoginName}
            onChange={props.handleChange}
            isStepSubmitted={props.isStepSubmitted}
            //handleError={handleError}
            //hasError={!isRequired(props.kioskLoginName).isValid}
            //errorMessage={getErrorMessage(isRequired(props.kioskLoginName))}
            showTooltip={true}
            tooltipTitle={Strings.TOOLTIP_INFO_TITLE.PERSONAL_ID}
            tooltipText={Strings.TOOLTIP_INFO_TEXT.PERSONAL_ID}
          />
        )}

        {!props.isGmtDetails && (
          <VerificationPINInput
            label={Strings.INPUT_LABELS.PERSIONAL_PIN}
            id={INPUTS_PROPS.PERSIONAL_PIN}
            value={props.kioskPIN}
            additionalDataId={props.additionalDataId}
            onChange={props.handleChange}
            codeVerifiedId={INPUTS_PROPS.CODE_VERIFIED}
            isCodeVerified={props.isCodeVerified}
            isStepSubmitted={props.isStepSubmitted}
            //handleError={handleError}
            //hasError={!isRequired(props.kioskPIN).isValid}
            //errorMessage={getErrorMessage(isRequired(props.kioskPIN))}
            isEditMode={props.isEditMode}
            kioskLoginName={props.kioskLoginName}
            updateKioskPIN={props.updateKioskPIN}
            fromGmt={props.fromGmt}
            showTooltip={true}
            tooltipTitle={Strings.TOOLTIP_INFO_TITLE.PERSONAL_PIN}
            tooltipText={Strings.TOOLTIP_INFO_TEXT.PERSONAL_PIN}
          />
        )}
        <TextInput
            classesToAdd={classes.noteField}
            label={Strings.INPUT_LABELS.NOTES}
            id={INPUTS_PROPS.NOTES}
            defaultValue={''}
            value={props.notes}
            onChange={props.handleChange}
            isStepSubmitted={props.isStepSubmitted}
            handleError={handleError}
            hasError={!isTextValid(props.notes).isValid}
            errorMessage={getErrorMessage(isTextValid(props.notes))}
            // showTooltip={false}
            // tooltipTitle={Strings.TOOLTIP_INFO_TITLE.PERSONAL_ID}
            // tooltipText={Strings.TOOLTIP_INFO_TEXT.PERSONAL_ID}
          />
          <div className={classes.messagingCheckboxContainer}>
            <CheckboxInput
              id={INPUTS_PROPS.IS_MESSAGING_ENABLED}
              checked={props.isMessagingEnabled}
              onChange={props.handleChange}
              name={INPUTS_PROPS.IS_MESSAGING_ENABLED}
              label={Strings.MESSAGING_SUBSCRIBED}
            />
          </div>
          <div className={classes.uploadImage}>
            <UploadImageInput
              id={INPUTS_PROPS.PROFILE_PICTURE}
              defaultValue={props.profilePicture}
              onChange={props.handleChange}
              image={props.profilePicture}
            />
            {/* <SwitchInput
              id={INPUTS_PROPS.APP}
              checked={props.app}
              onChange={props.handleChange}
              icon={Icons.APP}
              leftText={Strings.INPUT_LABELS.APP}
            /> */}
        </div>
      </div>
    </div>
  );
};

export default GeneralDetailsStep;
